export default "__VITE_ASSET__ef2d7ac7__"